import ApiConstants from "../../Constants/ApiConstant";
import { apiDelete, apiGet, apiPost, apiPut } from "../../Services/ApiService";
import { getUserRolePermission } from "../Slice/userRolePermissionSlice";

export const getUserRolePermissionByIdAPI = (userId, callBack) => {
  return async () => {
    try {
      await apiGet(`${ApiConstants.userRolePermissionUrl}?user_id=${userId}`)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("get user role permission api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("get user role permission api err:", err);
      throw err;
    }
  };
};

export const getUserRolePermissionByLoggedInUserAPI = (data, callBack) => {
  return async dispatch => {
    try {
      await apiGet(ApiConstants.userRolePermissionByLoggedInUserUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
          response?.status === true && dispatch(getUserRolePermission(response?.data))
        })
        .catch((err) => {
          console.log("get user role permission api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("get user role permission api err:", err);
      throw err;
    }
  };
};

export const addUserRolePermissionAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.userRolePermissionUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("add user role permission api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("add user role permission api err:", err);
      throw err;
    }
  };
};

export const updateUserRolePermissionAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPut(ApiConstants.userRolePermissionUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("update user role permission api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("update user role permission api err:", err);
      throw err;
    }
  };
};

export const deleteUserRolePermissionAPI = (userId, callBack) => {
  return async () => {
    try {
      await apiDelete(`${ApiConstants.userRolePermissionUrl}?user_id=${userId}`)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("delete user role permission api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("delete user role permission api err:", err);
      throw err;
    }
  };
};

